var quantityLabel = "Quantidade";
var quantityFlyoutHeader = "Escolha a quantidade";
var quantityFlyoutCTA = "Selecionar esta quantidade";
var closeButton = "Fechar";
var pricePlaceholder = "...";
var priceLabel = "Preço";
var unitPriceLabel = "Preço à unidade";
var incompatibilityMessage = "Não disponível com outras seleções: ";
var select = "Selecionar...";
var percentSavings = "Poupança de {{{PERCENT}}}%";
var sale = "venda";
var amountSavings = "Poupança de {{{AMOUNT}}} / unidade";
var amountSavingsWithSale = "Poupança de {{{AMOUNT}}} / unidade+ promoção";
var seeMoreQuantities = "Ver mais quantidades";
var required = "Obrigatório";
var sample = "Amostra";
var estimatedQuantity = "Quantidade estimada";
var numberOfRecipients = "{{{COUNT}}} destinatários";
var recommendedCallout = "Recomendado";
var newCallout = "Novidade";
var incompatibleLabel = "Incompatível";
var outOfStockCallout = "Esgotado";
var dismissAlert = "Dispensar alerta";
var unwindingMessage_1 = "Incompatível com {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "Incompatível com {{{ATTRIBUTE1}}} {{{OPTION1}}} e {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "Incompatível com {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} e {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "Incompatível com mais de {{{ATTRIBUTE_COUNT}}} opções.";
var unwindingAlertMessage_1 = "Para ser compatível com {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} foi desmarcado.";
var unwindingAlertMessage_2 = "Para ser compatível com {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} e {{{ATTRIBUTE2}}} {{{OPTION2}}} foram desmarcados.";
var unwindingAlertMessage_3 = "Para ser compatível com {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} e {{{ATTRIBUTE3}}} {{{OPTION3}}} foram desmarcados.";
var unwindingAlertMessage_more = "Para ser compatível com {{{ATTRIBUTE}}} {{{OPTION}}}: Mais de {{{ATTRIBUTE_COUNT}}} opções foram desmarcadas.";
var fullRangedHelperText = "{{{MINIMUM}}} {{{UNIT}}} a {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Pelo menos {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Introduza um valor entre {{{MINIMUM}}} e {{{MAXIMUM}}} páginas, incluindo a capa ";
var rangePartialRangedHelperTextForBooklets = "Pelo menos, {{{MINIMUM}}} páginas, incluindo a capa ";
var rangedGeneralInputError = "A entrada é inválida";
var rangedBetweenRangesError = "Os números mais próximos são {{{LOWER}}} {{{UNIT}}} e {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "O número não pode ter mais de 8 decimais";
var rangedMinInputValueError = "O número mínimo é {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "O número máximo é {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "O valor de entrada tem de ser um número";
var requiredAttributeFieldError = "Introduza um valor entre {{{LOWER}}} e {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "Os números mais próximos são {{{LOWER}}} páginas e {{{HIGHER}}} páginas ";
var rangedMinInputValueErrorForBooklets = "O número mínimo são {{{MINIMUM}}} páginas ";
var rangedMaxInputValueErrorForBooklets = "O número máximo são {{{MAXIMUM}}} páginas ";
var requiredAttributeFieldErrorForBooklets = "Introduza um valor entre {{{LOWER}}} e {{{HIGHER}}} páginas, incluindo a capa ";
var requiredInformationToast = "Indique todas as informações necessárias.";
var ptPt = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, ptPt as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=pt-pt.json.mjs.map
